import { maxLength, urlIsValid } from 'helpers/validate';
import { model } from 'helpers/model';

const applicationModel = {
  fields: ['signedIconUrl', 'name', 'description', 'url', 'iconUrl', 'oauth2RedirectUrls'],

  requiredFields: ['name', 'url'],

  initialValues: {},

  validate: values => ({
    // ie11
    url:
      !window.URL || !values['url']
        ? undefined
        : urlIsValid(values['url'])
          ? undefined
          : 'Must be a valid URL including protocol',
    description: maxLength(
      250,
      'Max length for description is 250 characters',
      values['description']
    ),
    name: maxLength(50, 'Max length for name is 50 characters', values['name']),
    // ie11
    oauth2RedirectUrls:
      !window.URL || !values['oauth2RedirectUrls']
        ? undefined
        : urlIsValid(values['oauth2RedirectUrls'])
          ? undefined
          : 'Must be a valid URL including protocol'
  })
};

export default model(applicationModel);



// WEBPACK FOOTER //
// ./src/client/modules/application/model.js